import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import selects from 'scoreboard/components/selects'

var MultichoiceFormView = FormView.extend({

	test: function() {
		return FormView.prototype.test.apply(this, arguments) ||
			_.isEmpty(this.$('select').val()) &&
				this.$('li.is-selected').length == 0 ?
				i18n.get('common.select.required') : null
	}

})

var MultiChoiceFilter = Backbone.View.extend({

	//this.data is a MultiChoiceFilter which is a java POJO

	className: 'multichoice-filter',

	events: {
		'click li': 'select'
	},

	initialize: function(options) {
		this.options = options
		this.data = _.assign({values:[], metadata: {}}, this.options.data)
		this._template = this.options.template
		var choices = _.result(this.options, 'choices', [])

		// #45591 for multichoice selects, add a default 'Add {Plural}...' placeholder
		const pluralLabel = _.result(this.options, 'pluralLabel', null)
		this.placeholder = _.isNil(pluralLabel) ? null : i18n.get('common.add4', pluralLabel)

		var activeSelections = this.data.values || []
		this.choices = _.map(choices, function(v,k) {
			if (_.isObject(v)) {
				return _.extend({selected: _.includes(activeSelections, v.id)}, v)
			}
			return {id: k, label: v, selected: _.includes(activeSelections, k) }
		})
		this.choicesMap = _.keyBy(this.choices, 'id')
		this.formViewType = MultichoiceFormView
	},

	render: function() {

		var ctx = {
			nameCode: this.options.nameCode,
			choices: this.choices
		}

		this.$el.html(this._template(ctx))

		if (this.options.customTemplate) {
			var selectable = {}
			//build hash of selectable columns
			this.$('li').each(function() {
				var li = $(this)
				selectable[li.data('value')] = li
			})

			//selected style is used to determine which items are selected, physical representation (i.e. checkmark) is set from 'selected' attribute
			_.forEach(this.data.values, function(value) {
				$(selectable[value]).toggleClass('is-selected', true)
			})
		} else {
			// Dialog needs to be opened all the way to prevent rich select from
			// being too tall on render.
			process.nextTick(() => {
				const options = _.cloneDeep(this.choices)
				_.each(options, o => {
					o.label = i18n.get(o.label)
					o.customIcon = o.icon
					o.value = o.id
					o.selected = !!_.find(this.data.values, v => v == o.id)
				})

				selects.filtering(this.$('select'), {
					multiple: true,
					options,
					placeholder: this.placeholder,
					sort: []
				})
			})
		}

		return this
	},

	select: function(e) {
		// #7193 - templates may contain an input element which captures this event
		// in addition to the li, we only want to handle one of them
		if (e.target.nodeName.toUpperCase() !== 'INPUT') {
			this.$(e.currentTarget).toggleClass('is-selected')
		}
		this.trigger('change', e)
	},

	//returns the data captured by this filter
	gather: function() {
		this.data.operator = 'contains-any'
		this.data.metadata = {}
		this.data.values = []
		let handleNullValue = this.options.handleNullValue
		this.$('option:selected, li.is-selected').each((i, option) => {
			let id = option.value || $(option).data('value')
			if (handleNullValue && _.isNull(id)) {
				id = handleNullValue()
			}
			this.data.values.push(id)
			this.data.metadata[id] = _.pick(this.choicesMap[id], 'id', 'label')
		})
		return this.data
	}
})

export default MultiChoiceFilter

MultiChoiceFilter.__filename__ = 'reports/common/filter/multichoice-filter.js'
